module.exports = __webpack_public_path__ + "static/media/rear-right.6c4b635c.jpg";